import React from 'react';
import { SubscriptionsRedirect } from '@members/pg-preferences/SubscriptionsRedirect';

export default function SubscriptionsRedirectPage() {
  return <SubscriptionsRedirect />;
}
